import React, { useState } from 'react'
// import OnVisible from 'react-on-visible'
import scrollIntoView from 'smooth-scroll-into-view-if-needed'
import { Section, Image, Link } from 'newComponents'
import './styles.scss'

const ComparisonTable = (props) => {
  const { data } = props
  const { primary, items } = data
  const [openToolTip, setOpenToolTip] = useState(false)
  const [activeColumn, setActiveColumn] = useState(null)

  // data
  const {
    column_logo_one: logoOne,
    column_logo_two: logoTwo,
    column_logo_three: logoThree,
    column_logo_four: logoFour,
    mobile_logo_one: mobileOne,
    mobile_logo_two: mobileTwo,
    mobile_logo_three: mobileThree,
    mobile_logo_four: mobileFour,
    logo_one_link: logoOneLink,
    logo_two_link: logoTwoLink,
    logo_three_link: logoThreeLink,
    logo_four_link: logoFourLink,
    cta_link: ctaLink,
    cta_text: ctaText,
    scroll_to_next: scrollToNext,
    title,
    content
  } = primary

  // content checks
  const titleHtml = title?.html
  const contentHtml = content?.html

  const logoHeaders = []
  // header data
  if (logoOne?.url) logoHeaders.push({ logo: logoOne, mobile: mobileOne, link: logoOneLink })
  if (logoTwo?.url) logoHeaders.push({ logo: logoTwo, mobile: mobileTwo, link: logoTwoLink })
  if (logoThree?.url) logoHeaders.push({ logo: logoThree, mobile: mobileThree, link: logoThreeLink })
  if (logoFour?.url) logoHeaders.push({ logo: logoFour, mobile: mobileFour, link: logoFourLink })
  // establish number of columns for conditional styling
  const columnNumber = ['one', 'two', 'three', 'four']
  const numberOfCols = columnNumber[logoHeaders?.length -1]

  // split html
  const getFeatureWithTooltip = (htmlString) => {
    const splitStr = htmlString.split('</strong>')
    if (splitStr.length === 1) return htmlString
    const tooltipText = splitStr[splitStr.length - 1]
    const strippedTooltip = tooltipText.replace('<br />', '').replace('</p>', '')
    const tooltipHtml = `</strong><span class="comparison-table-row-tooltip">${strippedTooltip}</span></p>`
    splitStr[splitStr.length - 1] = tooltipHtml
    return splitStr.join('')
  }
  // tool tip
  const handleClick = (index, text, event) => {
    event.preventDefault()
    setActiveColumn(text)
    if (index === 0) {
      if (openToolTip) {
        setOpenToolTip(false)
      }
      if (!openToolTip) {
        setOpenToolTip(true)
      }
    }
  }

  // handle click for table scroll
  const handleLinkClick = (event, hasHref) => {
    if (hasHref) return null

    if (scrollToNext) {
      event.preventDefault()

      const comparisonTables = document.querySelectorAll('.comparison-table')
      const nextTable = comparisonTables && comparisonTables[1]
      if (!nextTable) return null

      scrollIntoView(nextTable, { block: 'start' })
    }
  }

  return (
    <Section className={`comparison-table ${numberOfCols} ${ctaText?.text ? 'has-link' : ''}`}>
      {titleHtml && <div className="comparison-table-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
      {contentHtml && <div className="comparison-table-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />}
      <table className="comparison-table-container">
        {/* TABLE HEAD / TOP ROW */}
        <thead>
          {/* DUMMY/EMPTY COL/ROW */}
          <tr className="comparison-table-row">
            <th className="comparison-table-heading comparison-table-row-cell">
              <div />
            </th>
            <>
              {logoHeaders.map((heading) => {
                const { logo, mobile, link } = heading
                if (!logo) return null
                return (
                  <th className="comparison-table-heading comparison-table-row-cell" key={logo?.url}>
                    <Link to={link?.url || '#'}>
                      <Image className="comparison-table-header-logo" image={logo} />
                      <Image className="comparison-table-header-logo mobile" image={mobile} />
                    </Link>
                  </th>
                )
              })}
            </>
          </tr>
        </thead>
        {/* TABLE DATA  */}
        <tbody>
          {items.map((row, rowIndex) => {
            const { feature, row_data_2: rd2, row_data_3: rd3, row_data_4: rd4, row_data_5: rd5 } = row
            const rowRaw = [feature, rd2, rd3, rd4, rd5]
            const rowData = rowRaw.filter((rData) => rData?.text)

            if (!rowData[0]) return null

            return (
              <tr className="comparison-table-row" key={feature?.text || rowIndex}>
                {rowData.map((cell, columnIndex) => {
                  const { html: cellHtml, text } = cell
                  const htmlToUse = columnIndex === 0 ? getFeatureWithTooltip(cellHtml) : cellHtml
                  const isActiveColumn = activeColumn === text
                  const showClass = columnIndex === 0 && openToolTip && isActiveColumn ? 'open' : ''
                  return (
                    <td
                      className={`comparison-table-row-cell ${showClass}`}
                      key={`${text} + ${columnIndex}`}
                      onClick={(event) => handleClick(columnIndex, text, event)}
                    >
                      {cellHtml && (
                        <div
                          dangerouslySetInnerHTML={{ __html: htmlToUse }}
                          className={`comparison-table-row-cell-text ${text === 'Yes' ? 'yes' : ''}`}
                        />
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      {ctaText?.text && (
        <Link
          to={ctaLink?.url || '#nexttable'}
          className="comparison-table-cta"
          withChevron
          onClick={(event) => handleLinkClick(event, ctaLink?.url)}
          >
            {ctaText?.text}
          </Link>
        )}
    </Section>
  )
}

export default ComparisonTable
